import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 transition-all duration-300"
      title={language === 'tr' ? 'Switch to English' : 'Türkçe\'ye geç'}
    >
      <Globe className="w-4 h-4 text-[#4DD6FF]" />
      <span className="text-white text-sm font-medium">
        {language === 'tr' ? 'EN' : 'TR'}
      </span>
    </button>
  );
};

export default LanguageToggle;
